// Shared component styles. Preserve selector order, style values, and caller overrides.
export const PURPLE = "#9C4FFF";
export const BORDER = "#E5E7EB";
export const ACCORDION_HEADING_COLOR = "#3451F4";
export const ACCORDION_HEADING_SX = {
  fontFamily: "Be Vietnam Pro",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: 16,
  lineHeight: "24px",
  color: ACCORDION_HEADING_COLOR
};
export const accordionStyles = {
  viewButton: ({
    active
  }) => ({
    width: 30,
    height: 30,
    p: 0,
    borderRadius: 999,
    backgroundColor: active ? "rgba(124,58,237,0.10)" : "transparent",
    "&:hover": {
      backgroundColor: "rgba(124,58,237,0.08)"
    }
  }),
  root: ({
    isLast
  }) => ({
    border: "none",
    borderBottom: isLast ? "none" : `1px solid ${BORDER}`,
    borderRadius: 0,
    backgroundColor: "#fff",
    "&:before": {
      display: "none"
    }
  }),
  summary: () => ({
    px: 1.5,
    py: 0,
    minHeight: 44,
    "&.MuiAccordionSummary-root": {
      minHeight: 44
    },
    "& .MuiAccordionSummary-content": {
      my: 0,
      minHeight: 44,
      alignItems: "center"
    }
  }),
  headingRow: () => ({
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: 0
  }),
  headingIcon: ({
    headingColor
  }) => ({
    width: 24,
    height: 24,
    display: "grid",
    placeItems: "center",
    flex: "0 0 auto",
    boxSizing: "border-box",
    color: headingColor,
    "& svg:not([data-stage-icon='matched'])": {
      width: 24,
      height: 24,
      color: headingColor,
      stroke: headingColor,
      strokeWidth: "1px !important"
    },
    "& svg:not([data-stage-icon='matched']) *, & svg:not([data-stage-icon='matched']) path, & svg:not([data-stage-icon='matched']) circle, & svg:not([data-stage-icon='matched']) rect, & svg:not([data-stage-icon='matched']) line, & svg:not([data-stage-icon='matched']) polyline": {
      stroke: headingColor,
      strokeWidth: "1px !important"
    }
  }),
  heading: ({
    headingColor
  }) => ({
    ...ACCORDION_HEADING_SX,
    color: headingColor
  }),
  count: ({
    headingColor,
    pageSize
  }) => ({
    ...ACCORDION_HEADING_SX,
    color: headingColor,
    border: 0,
    background: "transparent",
    cursor: pageSize ? "pointer" : "inherit",
    textDecoration: pageSize ? "underline" : "none"
  }),
  spacer: () => ({
    flex: 1
  }),
  controls: () => ({
    display: "flex",
    alignItems: "center"
  }),
  viewControls: () => ({
    display: "flex",
    alignItems: "center",
    gap: 0.25
  }),
  divider: () => ({
    height: 18,
    mx: 0.75,
    borderLeft: `1px solid ${BORDER}`
  }),
  toggle: ({
    expanded
  }) => ({
    width: 30,
    height: 30,
    p: 0,
    borderRadius: 999,
    "&:hover": {
      backgroundColor: "rgba(124,58,237,0.08)"
    },
    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
    transition: "transform 160ms ease"
  }),
  details: () => ({
    px: 1.5,
    pb: 1.5,
    pt: 0.5
  }),
  missingGrid: () => ({
    fontFamily: "Be Vietnam Pro",
    fontSize: 12,
    fontWeight: 800,
    color: "#94A3B8"
  }),
  missingList: () => ({
    fontFamily: "Be Vietnam Pro",
    fontSize: 12,
    fontWeight: 800,
    color: "#94A3B8"
  }),
  emptyState: () => ({
    fontFamily: "Be Vietnam Pro",
    fontSize: 12,
    fontWeight: 800,
    color: "#94A3B8",
    py: 0.5
  }),
  pagination: () => ({
    ".MuiTablePagination-toolbar": {
      px: 0,
      minWidth: 0
    },
    ".MuiTablePagination-spacer": {
      flex: "1 1 auto"
    }
  }),
  list: () => ({
    borderTop: `1px solid ${BORDER}`
  })
};
